// extracted by mini-css-extract-plugin
module.exports = {"buttonControl":"CourseModules-tab_buttonControl_3vDOY","subheadingText":"CourseModules-tab_subheadingText_167HC","courseModuleList":"CourseModules-tab_courseModuleList_1574f"};